export default __webpack_public_path__ + "static/media/partnership_karier.fd0337b3.png";